// extracted by mini-css-extract-plugin
module.exports = {"container":"TopTitleRow_container__BtNug","title":"TopTitleRow_title__oz_J8"};